import { connect } from 'react-redux';

import ManualBillingPresentation from './ManualBillingPresentation';

import { manualBillingActions, invoicesActions, recursiveBillingSetupActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {
    const { 
        generateInvoice_errorMsg,
        postToSQLAccount_errorMsg,
        sendEmail_errorMsg,
        deleteInvoice_errorMsg,

        generateAppendix_requesting,
        generateInvoice_requesting,
        postToSQLAccount_requesting,
        sendEmail_requesting,
        deleteInvoice_requesting,

        deleteInvoice_status,

        totalRequests,
    } = state.invoicesReducers;

    const { 
        resetFirebirdService_requesting, 
        resetFirebirdService_errorMsg,
        resetFirebirdService_status,
    } = state.manualBillingReducers;

    const { userPermissions } = state.userManagementReducers;

    const {
        getExistingDealerCodeList_requesting, existingDealerCodeList,
        getExistingSalesPersonCodeList_requesting, existingSalesPersonCodeList,

        updateDealerCode_requesting, updateDealerCode_status, 
        updateSalesPersonCode_requesting, updateSalesPersonCode_status
    } = state.recursiveBillingSetupReducers;
    
	return {
        generateInvoice_errorMsg,
        postToSQLAccount_errorMsg,
        sendEmail_errorMsg,
        deleteInvoice_errorMsg,

        generateAppendix_requesting,
        generateInvoice_requesting,
        postToSQLAccount_requesting,
        sendEmail_requesting,
        deleteInvoice_requesting,
        
        deleteInvoice_status,

        resetFirebirdService_requesting, 
        resetFirebirdService_errorMsg,

        resetFirebirdService_status,
        
        totalRequests,

        userPermissions,

        getExistingDealerCodeList_requesting, existingDealerCodeList,
        getExistingSalesPersonCodeList_requesting, existingSalesPersonCodeList,

        updateDealerCode_requesting, updateDealerCode_status, 
        updateSalesPersonCode_requesting, updateSalesPersonCode_status
    };
}

function mapDispatchToProps(dispatch) {
    return {
        generateAppendix: (accountCode, datetime) => { dispatch(invoicesActions.generateAppendix(accountCode, datetime)); },
        generateInvoice: (accountCode, datetime) => { dispatch(invoicesActions.generateInvoice(accountCode, datetime)); },
        postToSQLAccount: (invoiceId) => { dispatch(invoicesActions.postToSQLAccount(invoiceId)); },
        sendEmail: (invoiceId, isSentToCustomers) => { dispatch(invoicesActions.sendEmail(invoiceId, isSentToCustomers)); },
        deleteInvoice: (invoiceId) => { dispatch(invoicesActions.deleteInvoice(invoiceId)); },
        resetFirebirdService: () => { dispatch(manualBillingActions.resetFirebirdService()); },

        getExistingDealerCodeList: () => { dispatch(recursiveBillingSetupActions.getExistingDealerCodeList()); },
        getExistingSalesPersonCodeList: () => { dispatch(recursiveBillingSetupActions.getExistingSalesPersonCodeList()); },

        updateDealerCode: (oldCode, newCode) => { dispatch(recursiveBillingSetupActions.updateDealerCode(oldCode, newCode)); },
        updateSalesPersonCode: (oldCode, newCode) => { dispatch(recursiveBillingSetupActions.updateSalesPersonCode(oldCode, newCode)); },
    };
}

const ManualBilling = connect(mapStateToProps, mapDispatchToProps)(ManualBillingPresentation);

export default ManualBilling;